<template>
<v-sheet :dark="dark" class="fill-height" :color="!dark ? 'background' : null">
  <v-app-bar flat color="transparent"
    fixed>
    <v-btn class="pl-2 app-btn" depressed fab small :to="'/dashboard'"><v-icon>arrow_back_ios</v-icon></v-btn>
    </v-app-bar>
     <v-parallax
     height="400"
    dark
    :src="banner"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <h1 class="text-h4 font-weight-thin mb-4">
          {{title}}
        </h1>
        <h4 class="subheading">
          Build your application today!
        </h4>
      </v-col>
    </v-row>
   
  </v-parallax>
  <v-card class="toolbar-gradient pt-4" flat color="transparent" tile>
    <v-card-title v-text="title"></v-card-title>
   <v-toolbar flat :dark="dark" :light="!dark" color="transparent">
       <v-btn icon v-if="!showSearch" @click="showSearch = true"
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
       <v-text-field v-model="search"  v-if="showSearch"
                        value="" 
                        placeholder="Zoek een gerecht of bestelling"
                        hide-details solo flat
                        background-color="transparent"
                        clearable
                        autofocus
                         class="mx-3 mt-1"
                        prepend-icon="mdi-magnify" @blur="showSearch=false"
                        v-on:keyup.enter="loadHub(search)"
                      ></v-text-field>
                      <v-chip-group v-else v-model="tab" active-class="primary" class="px-3" mandatory center-active show-arrows>
          <v-chip
            label
            :dark="tab==0"
            class="text-body-1"
            style="background-color: transparent"
            >Bestellingen
          </v-chip>
          <v-chip
            label
           :dark="tab==1"
            class="text-body-1"
            style="background-color: transparent"
            >Stempels
          </v-chip>
        </v-chip-group>
    </v-toolbar>
  </v-card>
   <v-card tile class="mx-auto pb-15 " flat color="transparent">
    
   <template v-if="tab==1">
    <v-card-title class="mt-4 primary--text">Stempels({{stamps.length}})</v-card-title>
    <v-card-subtitle>Bij elke bestelling krijg je een stempel. Heb je er 10 gespaard dan krijg je een gratis snack of drankje.</v-card-subtitle>
    <v-card-text>
    <stamp v-for="(stamp,i) in stamps" :key="'stamp' + i" :value="stamp" :text="stamp.name" class="mr-2">
        
    </stamp>
    </v-card-text>
   </template>
    <template v-else>
     <v-card-title class="mt-4 primary--text">Bestellingen</v-card-title>
  <v-card-text>

      <order-card v-for="(order,i) in orderlist"  class="mt-2" :key="order._id" :order="order"></order-card>
       <empty :dark="dark" v-if="orders.length==0" icon="mdi-silverware" description="Je hebt nog geen bestellingen gedaan. <br>Zoek je favoriete restaurant en doe je eerste bestelling."></empty>
  </v-card-text>
    </template>
  </v-card>
  <footer-info orders></footer-info>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../components/PageHeader.vue";

import Onboarding from "../components/Onboarding.vue";
import OrderCard from "../components/OrderCard.vue";
import headerItem from "@/modules/headerItem";
import empty from "@/components/empty";
import stamp from "@/components/stamp";
import FooterInfo from '../components/FooterInfo.vue'
export default {
  mixins: [headerItem],
  components: {
    PageHeader,
    FooterInfo,
    Onboarding,
    stamp,
    OrderCard,
    empty,
  },
  data() {
    return {
      loading: true,
      model: 0,
      model2: null,
      showSearch: false,
      drawer: false,
      search: null,
      list: []
    };
  },
  computed: {
    ...mapGetters(["hub","orders"]),
    host() {
      return this.$config.page
    },
    banner() {
      return this.host.banner;
    },
    title() {
      return "Bestellingen";
    },
    tab: {
      get(){
        return this.$route.query.tab*1 || 0
      },
      set(value){
        this.$router.push({query: {tab: value}})
      }
    },
    stamps(){
      let stamps = []
      this.orderlist.filter(o=>o._stamps>0).map(s=>{
        for (let i=0; i <s._stamps;i++){
          stamps.push({
          stamp: s._host.stamp || s._host.logo,
          name: s._host.name})
        }
      })
      return stamps
    },
    orderlist(){
      if (!this.search) return this.orders
      return this.orders.filter(order=> 
          order.name.toLowerCase().includes(this.search.toLowerCase())
          || order._items.filter(item=>(item.$name && item.$name.toLowerCase().includes(this.search.toLowerCase())) 
                                || (item.$subname && item.$subname.toLowerCase().includes(this.search.toLowerCase()))).length > 0)
    }
  },
  created: async function () {
    // `this` points to the vm instance
    
  },
  mounted() {
    if (this.$store.state.token) {
      this.load();
    }
  },
  watch: {
    tabs(value) {},
  },
  methods: {
    ...mapActions([
      "setConfig",
      "resetCart",
      "setHub",
      "setHost",
      "logout",
      "login",
      "setOrders"
    ]),
    serchMe(q){
        //console.log(q)
    },
    async load(search) {
      this.resetCart();
      this.setHost();
      let response = await this.$http.post("/api/order/list", {});
      this.setOrders(response.data);
      this.setConfig('orders')
       //if (this.isCustomer)
    },
    
  },
};
</script>
<style >

</style>
